var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ zIndex: _vm.zIndex })},[_c('div',{class:{ 'bottom-shadow': _vm.isSticky },style:(_vm.stickyStyle)},[_vm._t("default",[_c('div',[_vm._v("sticky")])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }